import { 
    gql, 
    useQuery 
} from "@apollo/client";
import { 
  FindAdminMerchantsQueryQuery
} from "../../../../schemaTypes";

export const findAdminMerchantsQuery = gql`
  query FindAdminMerchantsQuery{
    findAdminMerchants{
        id
        businessName
        businessType
        businessRegNumber
        companyName
        username
        logoUrl
        createdAt
        adminId
        userId
    }
  }
`;

export interface WithFindAdminMerchants {
  id: string;
  businessName: string;
  businessType: string;
  businessRegNumber: string;
  companyName: string;
  username: string;
  logoUrl: string;
  createdAt: string;
  adminId: string;
  userId: string;
}

export function useFindAdminMerchants() {
  const { data, loading } = useQuery<
    FindAdminMerchantsQueryQuery
  >(findAdminMerchantsQuery,
    {
      notifyOnNetworkStatusChange: true,
    }
  );

  return {
    merchants: data?.findAdminMerchants ?? [],
    loading
  };
}
